import QRCode from 'qrcode'

export function drawQRCode(canvas, text, size) {
  if (!canvas || !text) return
  QRCode.toCanvas(canvas, text, {
    width: size,
    margin: 2,
    color: { dark: '#000000', light: '#ffffff' }
  })
}
